import { useDispatch } from "react-redux";
import { Box, Text } from "theme-ui";
import nl2br from "react-nl2br";

import { dismissNotification } from "store/app/appSlice";
import { CloseButton } from "components";
import { InfoIcon } from "components/icons";
import * as styles from "./notifications.styles";

function NotificationIcon({ icon }) {
  switch (icon) {
    case "InfoIcon":
      return <InfoIcon />;

    default:
      return null;
  }
}

function Notification({
  id,
  notificationType,
  content,
  links,
  icon,
  canClose,
}) {
  const dispatch = useDispatch();

  const handleCloseClick = () => {
    dispatch(dismissNotification(id));
  };

  return (
    <Box
      sx={styles.notification({
        notificationType,
        hasIcon: Boolean(icon),
        hasCloseButton: canClose,
      })}
    >
      {icon && <NotificationIcon icon={icon} />}
      {links ? (
        <Text>
          Unfortunately, the stick that you have chosen is currently
          out-of-stock. You can still purchase this stick through{" "}
          <a
            href={links[0].url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", marginRight: "5px", fontWeight: "bold" }}
          >
            {links[0].title}
          </a>{" "}
          or available now in{" "}
          <a
            href={links[1].url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "white", marginRight: "5px", fontWeight: "bold" }}
          >
            {links[1].title}
          </a>
          .
        </Text>
      ) : (
        <Text>{nl2br(content)}</Text>
      )}
      {canClose && (
        <CloseButton onClick={handleCloseClick} sx={styles.closeButton} />
      )}
    </Box>
  );
}

export default function Notifcations({ notifications = [], canClose = false }) {
  return (
    <Box sx={styles.notifications}>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          {...notification}
          canClose={canClose}
        />
      ))}
    </Box>
  );
}
